import React,{ useState } from 'react';
import { Modal, Button } from 'react-bootstrap';


const UserButton = ({showModal, handleCloseModal}) => {

    const [selectedRole, setSelectedRole] = useState('');
    const handleRoleChange = (event) => {
        setSelectedRole(event.target.value);
    };
    const dropdownStyling = {
        padding: '3px',
        fontSize: '0.9rem',
        border: '1px solid #ccc',
        borderRadius: '5px',
        outline: 'none',
        color: '#333',
        width: '200px',
        height: '31px',
        cursor: 'pointer',
        marginLeft: '150px',
    };
    const [selectedRoled, setSelectedRoled] = useState('');
    const handleRoledChange = (event) => {
        setSelectedRoled(event.target.value);
    };
    const dropdownStyled = {
        padding: '3px',
        fontSize: '0.9rem',
        border: '1px solid #ccc',
        borderRadius: '5px',
        outline: 'none',
        color: '#333',
        width: '200px',
        height: '31px',
        cursor: 'pointer',
        marginLeft: '110px',
    };
  return (
    <div>
   <Modal show={showModal} onHide={handleCloseModal} dialogClassName="modal-90w" size="lg">
        <Modal.Header closeButton style={{ backgroundColor: '#004aad', borderColor: '#004aad' }}>
            <Modal.Title style={{ color: 'white' }}></Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <h4>Add User Payment</h4>
            <h6>User Payment Details</h6>
            <div style={{
                alignItems: 'center',
                fontSize: '0.9rem',
                marginRight: '20px',
                gap: '50px',
                backgroundColor: '#f2f2f2'
            }}><br/> 
                <strong style={{marginLeft:"10px"}}>User</strong>
                <select value={selectedRole} onChange={handleRoleChange} style={dropdownStyling}>
                    <option value="Select User">Select User</option>
                    <option value="Admin SM">Admin SM</option>
                    <option value="Hira KH">Hira KH</option>
                    <option value="Hira Admin">Hira Admin</option>
                </select>
                <br />
                <br/>
                <strong style={{marginLeft:"10px"}}>Procedure</strong>
                <select value={selectedRoled} onChange={handleRoledChange} style={dropdownStyled}>
                    <option value="Related Procedure "><b>Related Procedure </b> </option>
                    <option value=" PRV YEHLLOW CROWN">PRV YEHLLOW CROWN</option>
                    <option value="NHS NIGHT GUARD"> NHS NIGHT GUARD </option>
                    <option value="PRV POST AND CORE">PRV POST AND CORE </option>
                    <option value="IND PORCELAIN BONDED BRIDGE 2-3">IND PORCELAIN BONDED BRIDGE 2-3 </option>
                    <option value="IND PORCELAIN BONDED BRIDGE 4+"> IND PORCELAIN BONDED BRIDGE 4+ </option>
                    <option value="IND PORCELAIN BONDED CROWN ">IND PORCELAIN BONDED CROWN </option>
                    <option value=" IND METAL INLAY/ONLAY">IND METAL INLAY/ONLAY </option>
                    <option value="NHS POST AND CORE">NHS POST AND CORE</option>
                </select>
                <br/>
                <br/>
                <strong style={{marginLeft:"10px"}}>Amount (£)</strong>
                <input
            type="number"
            style={{
              border: '2px solid #ccc',
              borderRadius: '4px',
              padding: '8px',
              width: '90px',
              height: '37px',
              marginLeft: '106px'
            }}
          /><br/><br/>
            </div>
        </Modal.Body>
        <Modal.Footer>
            <Button
                variant="secondary"
                onClick={handleCloseModal}
                style={{ backgroundColor: '#004aad', borderColor: '#004aad' }}
            >
                Cancel
            </Button>
            <Button
                variant="primary"
                onClick={handleCloseModal}
                style={{ backgroundColor: '#004aad', borderColor: '#004aad'}}
            >
                Save
            </Button>
        </Modal.Footer>
    </Modal>
</div>
  )
}

export default UserButton;